import type { AppRoute } from '../types';
import ErrorMaintenance from '../components/ErrorMaintenance/ErrorMaintenance';
import { RouteTypeEnum } from '../types';

export enum ErrorsRoutesEnum {
  Maintenance = '/error/maintenance',
}

const errorsRoutes: AppRoute[] = [
  {
    id: 'error:maintenance',
    path: ErrorsRoutesEnum.Maintenance,
    type: RouteTypeEnum.Public,
    component: ErrorMaintenance,
  },
];

export default errorsRoutes;
